import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  let organization_ids = useDataValue({
    context: 'setup',
    path: 'organization_ids',
    viewPath: props.viewPath,
  })

  return {
    variables: { organization_ids },
  }
}
